export const PAGE_TYPES = {
    SITE_DETAIL: 'site-detail',
    SITE_OWNER: 'site-owner',
    SITE_GATEWAY_DETAIL: 'site-gateway-detail',
    SITE_HISTORY: 'site-history',
} as const;

export type PageType = (typeof PAGE_TYPES)[keyof typeof PAGE_TYPES];
